import type { CellValue } from "../../../types/types";

interface CellDateProps {
    cellValue: CellValue;
}

export const CellDateValue = ({ cellValue }: CellDateProps) => {
    function formatDate(input: string): string {
        const date = new Date(input);
        const pad = (n: number) => n.toString().padStart(2, "0");
        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1); // Months are zero-indexed
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    const dateTime = typeof cellValue === "string" ? formatDate(cellValue) : "";

    return <span>{dateTime}</span>;
};
